import React, { useState, useEffect, useCallback } from "react";
import {
  Alert,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Progress,
  Row,
  Table,
} from "reactstrap";
import DatePickerMulti from "react-multi-date-picker";
import { Button } from "reactstrap";
import { BiCalendarAlt, BiCheck, BiHash, BiRecycle, BiX } from "react-icons/bi";
import { BsChevronDown, BsDownload, BsStars } from "react-icons/bs";
import moment from "moment";
import EmptyTable from "../../../components/EmptyTable/EmptyTable";
import parse from "react-html-parser";
import html2canvas from "html2canvas";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import MultirangeDatePickerDesigned from "./MultirangeDatePickerDesigned";
import withLoading from "../../../hoc/Loading/Loading";
import { CSVLink } from "react-csv";
import { FaThumbsUp } from "react-icons/fa6";
import {
  ATTEMPT_NO_FILTER,
  CUSTOM_QUESTION_INPUT_TYPES,
  formatDuration,
  getAttemptNumberFilterOptions,
  getInputTypeLabel,
  getTrivvyRating,
  isTrivvyGeneratedFromCustomTemplates,
  minPlanLimitCheck,
  sentimentPercent,
  SENTIMENTS_TYPO_MAP,
} from "../data";
import {
  contvertHTMLToPlain,
  profilePicValidityCheck,
} from "../../../utils/constants";
import { isMobile } from "../../../utils/deviceInfo";
import Select from "react-select";
import { toastContainer } from "../../../utils/toast";
import { marked } from "marked";
import { MdBusAlert, MdUpgrade } from "react-icons/md";

import SummaryPieChart from "./SummaryPieChart";
import SpinnerLoader from "../../../components/UI/SpinnerLoader/SpinnerLoader";
import TrivvyDropoffsModal from "./TrivvyDropoffsModal";
import GreyOutUpgradePlanuBlockUi from "../../../components/Shared/GreyOutUpgradePlanuBlockUi";
import TriviaResultsResponses from "./TriviaResultsResponses";
import Plot from "../../../utils/customPlotly";
import LinearNumericBarGraph from "./Results/LinearNumericBarGraph";
import TextSentimentComponent from "./Results/TextSentimentComponent";
import TextSentimentComponentOverall from "./Results/TextSentimentComponentOverall";
import OptionsPiechart from "./Results/OptionsPiechart";
import placeHolderInsights from "../../../assets/trivvy/placeholder_insights.png";

function TriviaResultsSummary({
  questions,
  surveyId,
  allowAttempts,
  currentTrivvy,
  setCurrentTrivia,
  user,
}) {

  console.log(questions, "questions");
  const [dateRange, setDateRange] = useState([new Date()]);
  const [attemptNumber, setAttemptNumber] = useState(0);
  const [summaryApiLoading, setSummaryApiLoading] = useState(false);
  const [openDropOffModal, setOpenDropOffModal] = useState(false);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [openSubmissionModal, setOpenSubmissionsModal] = useState(false);
  const [surveyInsights, setSurveyInsights] = useState(
    currentTrivvy.surveyInsights || {}
  );
console.log(questions, "questions");
  useEffect(()=>{
    setSurveyInsights(currentTrivvy.surveyInsights)
 },[currentTrivvy])
  const handleDateChange = (value) => {
    const items = value.map((x) => new Date(x));
    setDateRange(items);
    if (items.length == 2 || items.length == 0) {
      getSummaryData({
        attempts: attemptNumber,
        dates: items,
      });
    }
  };

  const [isFiltersApplied, setIsFilterApplied] = useState(false);
  const [insightsLoading, setInsightsLoading] = useState(false);

  const trivvyHasSingleTextQuestion =
    currentTrivvy && currentTrivvy.questions
      ? currentTrivvy.questions.filter((x) => x.question_type == "TEXT")
        .length > 0
      : false;

  const isMcQTrivvy =
    questions && questions.filter((x) => x.question_type == "MCQ").length > 0;
  
  // Check if it's a KC with retakes allowed (same as TriviaResultsResponses)
  const isKC = currentTrivvy && currentTrivvy.uploadType !== null && currentTrivvy.uploadType !== undefined;
  const hasRetakes = allowAttempts > 0;
  const showRetakesColumn = isKC && hasRetakes;

  // State to hold recalculated questions data when retakes are allowed
  const [processedQuestions, setProcessedQuestions] = useState(null);
  const [retakesDataLoading, setRetakesDataLoading] = useState(false);
  const [uniqueUserCount, setUniqueUserCount] = useState(null);
  
  const [summaryData, setSummaryData] = useState({});
  const getSummaryData = (filters) => {
    setSummaryApiLoading(true);
    axios
      .post(url.getTriviaInsightsSummary(surveyId), { filter: filters })
      .then(({ data }) => {
        setSummaryApiLoading(false);
        let doc = {};
        if (filters != null) {
          setIsFilterApplied(true);
          doc = { ...data.data };
          if (!doc.submitted_docs) {
            doc.submitted_docs = 0;
          }
          if (!doc.started_docs) {
            doc.started_docs = 0;
          }
          if (!doc.question_responses_records) {
            doc.question_responses_records = [];
          }
          if (!doc.option_response_matching_records) {
            doc.option_response_matching_records = [];
          }
          if (
            !doc.sentiment_data ||
            (doc.sentiment_data && !doc.sentiment_data.sentiment)
          ) {
            doc.sentiment_data = null;
          } else {
          }
        } else {
          setIsFilterApplied(false);
          doc.started_docs = data.data.started_docs || 0;
          doc.submitted_docs = currentTrivvy.totalSubmissions || 0;
        }
        setSummaryData(doc);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  

  useEffect(() => {
    // getSummaryData(null);
  }, []);

  // When retakes are allowed, fetch submissions and recalculate stats using only latest per user
  useEffect(() => {
    if (showRetakesColumn && surveyId && questions && questions.length > 0) {
      setRetakesDataLoading(true);
      axios
        .post(url.getTriviaSubmissions(surveyId))
        .then(({ data }) => {
          const rawData = data.data || [];
          
          // Group by user and keep only latest submission (same logic as TriviaResultsResponses)
          const userSubmissionsMap = {};
          rawData.forEach((result) => {
            // Try userId._id first, then fallback to userData.email for external users
            const userKey = (result.userId && result.userId._id) || 
                            (result.userData && result.userData.email);
            if (userKey) {
              if (!userSubmissionsMap[userKey]) {
                userSubmissionsMap[userKey] = [];
              }
              userSubmissionsMap[userKey].push(result);
            }
          });

          // Keep only the latest submission per user
          const latestSubmissions = [];
          Object.values(userSubmissionsMap).forEach((submissions) => {
            const sortedSubmissions = submissions.sort((a, b) =>
              new Date(b.isSubmittedDate || b.createdOn) - new Date(a.isSubmittedDate || a.createdOn)
            );
            latestSubmissions.push(sortedSubmissions[0]);
          });

          // Store unique user count for total_people_counts calculation
          setUniqueUserCount(latestSubmissions.length);

          // Recalculate question/option stats from filtered submissions
          const recalculatedQuestions = questions.map((question) => {
            const questionCopy = { ...question };
            
            // Initialize counters
            let totalResponses = 0;
            const optionCounts = {};
            const linearNumericCounts = {};
            const sentimentCounts = { POSITIVE: 0, NEGATIVE: 0, NEUTRAL: 0 };
            
            // Initialize option counts
            if (question.options) {
              question.options.forEach((opt) => {
                optionCounts[opt.option_id] = 0;
              });
            }
            
            // Initialize linear numeric counts
            if (question.question_type === "LINEAR_NUMERIC" && question.linearNumericConfigs) {
              for (let i = question.linearNumericConfigs.min; i <= question.linearNumericConfigs.max; i++) {
                linearNumericCounts[i] = 0;
              }
            }

            // Process each latest submission
            latestSubmissions.forEach((submission) => {
              const response = submission.responses && submission.responses.find(
                (r) => r.question_id === question.question_id
              );
              
              if (response && response.selected_answers && response.selected_answers.length > 0) {
                totalResponses++;
                
                // For MCQ questions - count option selections
                if (question.question_type === "MCQ") {
                  response.selected_answers.forEach((answer) => {
                    if (answer.option_id && optionCounts.hasOwnProperty(answer.option_id)) {
                      optionCounts[answer.option_id]++;
                    }
                  });
                }
                
                // For LINEAR_NUMERIC questions - count scale selections
                if (question.question_type === "LINEAR_NUMERIC") {
                  const selectedValue = response.selected_answers[0] && response.selected_answers[0].text;
                  if (selectedValue) {
                    const numValue = parseInt(selectedValue);
                    if (!isNaN(numValue) && linearNumericCounts.hasOwnProperty(numValue)) {
                      linearNumericCounts[numValue]++;
                    }
                  }
                }
                
                // For TEXT questions - count sentiments
                if (question.question_type === "TEXT" && response.textSentimentsData && response.textSentimentsData.sentiment) {
                  const sentiment = response.textSentimentsData.sentiment;
                  if (sentimentCounts.hasOwnProperty(sentiment)) {
                    sentimentCounts[sentiment]++;
                  }
                }
              }
            });

            // Update question with recalculated stats
            questionCopy.users_responded = totalResponses;
            questionCopy.totalResponses = totalResponses;
            
            // Update options with recalculated counts
            if (questionCopy.options) {
              questionCopy.options = questionCopy.options.map((opt) => ({
                ...opt,
                totalResponded: optionCounts[opt.option_id] || 0,
              }));
            }
            
            // Update linear numeric counts
            if (question.question_type === "LINEAR_NUMERIC") {
              questionCopy.linearNumericResponsesCounts = linearNumericCounts;
            }
            
            // Update sentiment counts
            if (question.question_type === "TEXT") {
              questionCopy.sentimentCounts = sentimentCounts;
            }

            return questionCopy;
          });

          setProcessedQuestions(recalculatedQuestions);
          setRetakesDataLoading(false);
        })
        .catch((err) => {
          console.log('Error fetching submissions for retakes:', err);
          setRetakesDataLoading(false);
        });
    }
  }, [showRetakesColumn, surveyId, questions]);

  // Use processedQuestions when retakes are allowed, otherwise use original questions
  const displayQuestions = showRetakesColumn && processedQuestions ? processedQuestions : questions;

  let total_people_counts = 0;

  console.log('currentTrivvy - ', currentTrivvy)

  // When retakes are allowed, use unique user count instead of total submissions
  if (showRetakesColumn && uniqueUserCount !== null) {
    total_people_counts = uniqueUserCount;
  } else if (summaryData && (summaryData.submitted_docs|| summaryData.started_docs)) {
    total_people_counts = summaryData.submitted_docs + summaryData.started_docs;
  } else if(currentTrivvy){
    total_people_counts = currentTrivvy.questionTotalCount ? currentTrivvy.questionTotalCount: (currentTrivvy.startCount || currentTrivvy.totalSubmissions )
  }



  const getDataForSummary = useCallback(() => {
    if (
      summaryData &&
      questions &&
      questions.length &&
      (isFiltersApplied ||
        (summaryData.question_responses_records &&
          summaryData.question_responses_records.length))
    ) {
      const questionAnswerArray = questions.map((question) => {
        const object = {
          question: `${contvertHTMLToPlain(question.question_text)} ${getInputTypeLabel(question.question_type)
              ? `(${getInputTypeLabel(question.question_type)})`
              : ""
            }`,
          answer:
            question.correct_options && question.correct_options[0]
              ? question.correct_options[0].text
              : "None",
        };

        let questionResCount = 0;
        const question_doc = isFiltersApplied 
          ?  summaryData.question_responses_records && summaryData.question_responses_records.find(
            (x) => x._id === question.question_id
          )
          : { ...question };

          console.log('233 question_doc -- ', question_doc)

        if (!question_doc) {
          questionResCount = 0;
        } else {
          questionResCount = question_doc.totalResponses;
        }

        let isRangeQuestion = false;
        let rangeAverage = 0;
        let isCustomTextQuestion = false;
        let remainingTextQuestions = 0;
        let maxAvgLimit = 0;

        if (question.question_type == "LINEAR_NUMERIC") {
          maxAvgLimit = question.linearNumericConfigs
            ? question.linearNumericConfigs.max || 0
            : 0;
        }

        console.log('253 question_doc -- ', question_doc)

        if (question_doc && question_doc.userResponses) {
          const userResponses = [...question_doc.userResponses];

          if (
            userResponses[0] &&
            userResponses[0].question_type == "LINEAR_NUMERIC"
          ) {
            isRangeQuestion = true;

            const selectedAnswersStrings = [];

            for (const res of userResponses) {
              if (res.selected_answers && res.selected_answers[0]) {
                selectedAnswersStrings.push(res.selected_answers[0].text);
              }
            }

            const selectedAnswersNums = selectedAnswersStrings.map((x) => {
              try {
                return parseInt(x);
              } catch (error) {
                return 0;
              }
            });

            const totalSum = selectedAnswersNums.reduce(
              (accumulator, currentValue) => {
                return accumulator + currentValue;
              },
              0
            );

            rangeAverage = Math.round(
              totalSum / selectedAnswersNums.length
            );
          } else if (
            userResponses[0] &&
            userResponses[0].question_type == "TEXT"
          ) {
            isCustomTextQuestion = true;
            remainingTextQuestions = total_people_counts - questionResCount;
          }
        } else {
          if (question.question_type === "LINEAR_NUMERIC") {
            isRangeQuestion = true;

            const selectedAnswersStrings =
              question.linearNumericResponsesCounts &&
                Object.keys(question.linearNumericResponsesCounts).length
                ? Object.values(question.linearNumericResponsesCounts)
                : [];

            const selectedAnswersNums = selectedAnswersStrings.map((x) => {
              try {
                return parseInt(x);
              } catch (error) {
                return 0;
              }
            });

            const totalSum = selectedAnswersNums.reduce(
              (accumulator, currentValue) => {
                return accumulator + currentValue;
              },
              0
            );

            rangeAverage = Math.round(
              totalSum / selectedAnswersNums.length
            );
          } else if (question.question_type === "TEXT") {
            isCustomTextQuestion = true;
            remainingTextQuestions = total_people_counts - questionResCount;
          }
        }

        if (question.question_type != "MCQ") {
          if (question.question_type == "TEXT") {
            object["answer"] = `Responded${Math.round(
              (questionResCount / total_people_counts) * 100
            )}% (${questionResCount})`;
          }
          if (question.question_type == "LINEAR_NUMERIC") {
            object["answer"] = `${rangeAverage}/ ${question.linearNumericConfigs
                ? question.linearNumericConfigs.max
                : ""
              } (${questionResCount}) `;
          }
        }

        for (let index = 0; index < question.options.length; index++) {
          const option = question.options[index];

          let optionResCount = 0;
          const option_doc = isFiltersApplied
            ? summaryData.option_response_matching_records && summaryData.option_response_matching_records.find(
              (x) => x._id === option.option_id
            )
            : option;

          if (!option_doc) {
            optionResCount = 0;
          } else {
            optionResCount =
              option_doc.totalResponses || option_doc.totalResponded;
          }
          const progressVal =
            questionResCount > 0
              ? Math.round((optionResCount / questionResCount) * 100)
              : 0;
          object[`option${index + 1}`] = `${progressVal}% (${optionResCount})`;
        }
        return object;
      });

      const finalData = [];

      for (let index = 0; index < questions.length; index++) {
        if (index == 0) {
          finalData.push({
            dropOffs: summaryData.started_docs,
            submissions: summaryData.submitted_docs,
            completionRate: ` ${Math.round(
              (summaryData.submitted_docs /
                (summaryData.submitted_docs + summaryData.started_docs)) *
              100
            )} %`,
            averageTime: summaryData.total_avg_time
              ? `${parseFloat(summaryData.total_avg_time).toFixed(2)} sec`
              : "0 sec",
            ...questionAnswerArray[index],
          });
        } else {
          finalData.push({
            dropOffs: "",
            submissions: "",
            completionRate: "",
            averageTime: "",
            ...questionAnswerArray[index],
          });
        }
      }

      return finalData;
    } else {
      return [];
    }
  }, [summaryData]);

  const summarizeCustomQuestionAnswers = (questionId) => {
    axios
      .post(url.sumarizeTextInputResponses, {
        triviaId: surveyId,
        questionId,
      })
      .then(({ data }) => {
        setCurrentTrivia({
          ...currentTrivvy,
          questions: data.data.questions,
        });
      })
      .catch((err) => {
        toastContainer("Error while generating summary");
      });
  };

  const [isEndDateBeforeToday, setIsEndDateBeforeToday] = useState(false);

  useEffect(() => {
    if (currentTrivvy) {
      if (!currentTrivvy.trivvyEndDate) {
        setIsEndDateBeforeToday(true);
      }
      else if (moment(currentTrivvy.trivvyEndDate).isSameOrBefore(moment(), "day")) {
        setIsEndDateBeforeToday(true);
      }
    }
  }, [currentTrivvy]);

  const trivvyPlanType =
    user && user.organizationId && user.organizationId.trivvyPlanType;

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  const consturctUserObjForExternalUser = (obj) => {
    if (obj.email) {
      return {
        firstName: obj.email,
        identification: "[Email]-",
      };
    } else if (obj.name) {
      const arr = obj.name.split(" ");
      return {
        identification: "[Name]-",
        firstName: arr[0],
        lastName: arr[1] || "",
      };
    } else {
      return {
        identification: "[EmployeeId]-",

        firstName: obj.employeeId,
      };
    }
  };
  const renderUserName = (data) => {
    if (!data.isAnonymous) {
      if (data.userId && data.userId._id) {
        return (
          <span className="trivia_table_text_wrapper">
            {profilePicValidityCheck(data.userId.profilePic) ? (
              <img
                src={data.userId.profilePic}
                height="35px"
                width="35px"
                style={{ borderRadius: "50%" }}
              />
            ) : (
              <span
                className="spotlightUserInitials"
                data-letters={getInitials(data.userId)}
              ></span>
            )}{" "}
            {data.userId.firstName} {data.userId.lastName}
          </span>
        );
      } else if (data.userData) {
        return (
          <span>
            {consturctUserObjForExternalUser(data.userData).firstName}{" "}
            {consturctUserObjForExternalUser(data.userData).lastName}
          </span>
        );
      } else {
        return "User";
      }
    } else {
      return "Anonymous user";
    }
  };

  const isNonMcQTrivvy =
    questions &&
    questions.filter(
      (x) =>
        x.question_type == "MCQ" && x.correct_options && x.correct_options[0]
    ).length == 0;

  const generateTextQuestionInsights = (questionId, isRegenerate) => {
    setInsightsLoading(true)
    axios
      .post(url.generateInsightsForTextTrivvyQuestion, {
        triviaId: currentTrivvy._id,
        questionId,
        regenerate: isRegenerate,
        oldText: surveyInsights ? surveyInsights[questionId] : "",
      })
      .then(({ data }) => {
        setInsightsLoading(false)
        setSurveyInsights({
          ...surveyInsights,
          [questionId]: data.data.generatedText,
        });
        setCurrentTrivia({
          ...currentTrivvy,
          surveyInsights:{
            ...surveyInsights,
            [questionId]: data.data.generatedText,
          }
        })
      })
      .catch((err) => {
        setInsightsLoading(false)
        console.log(err);
      });
  };

  const generatePDF = async () => {
    setIsGeneratingPDF(true);

    const pdfTarget = document.getElementById('pdf_content_container');

    // Remove previous header if exists
    const existingHeader = pdfTarget.querySelector('.export-header');
    if (existingHeader) {
      existingHeader.remove();
    }

    // Create new header
    const headerDiv = document.createElement("div");
    headerDiv.className = "export-header"; // Add identifiable class
    headerDiv.style.marginBottom = "40px";
    headerDiv.style.marginLeft = "25px";
    headerDiv.style.textAlign = "left";

    const title = document.createElement("h1");
    title.style.margin = "0";
    title.innerText = currentTrivvy.name || "Trivvy";

    const subtitle = document.createElement("p");
    subtitle.style.margin = "0";
    subtitle.innerText = `Exported on: ${moment().format("MMMM Do YYYY")}`;

    headerDiv.appendChild(title);
    headerDiv.appendChild(subtitle);
    pdfTarget.prepend(headerDiv);
    pdfTarget.style.display = 'block';

    // Let lazy-loaded Plotly charts and any pending paint complete before capture.
    await new Promise((resolve) => requestAnimationFrame(resolve));

    const filename = `${moment().format('dddd, MMMM Do YYYY')} - ${currentTrivvy.name || "Trivvy"} Questions Summary.pdf`;
    const SCALE = 2;
    const opts = {
      margin: [0.5, 0.2, 0.5, 0.2],
      filename,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: SCALE, useCORS: true, scrollX: 0, scrollY: 0 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
      // Use CSS-driven page breaks (the html2pdf default). 'avoid-all' adds
      // `page-break-inside: avoid` to every element, which causes content
      // taller than a page (e.g., long AI-insights bullet lists) to repeat
      // on consecutive pages — the slicer can't find a valid break inside
      // an element that won't fit anywhere whole.
      pagebreak: { mode: ['css', 'legacy'] },
    };

    // Chrome caps canvas dimensions around 32,767 px. With scale: 2, a 41-page
    // trivvy renders to ~86,000 px tall — past the cap, so html2canvas silently
    // produces a blank canvas and html2pdf slices it into N blank pages
    // (the bug we're fixing). 14,000 px gives safe headroom under the cap.
    const SAFE_CANVAS_LIMIT_PX = 14000;
    const totalHeightPx = pdfTarget.offsetHeight * SCALE;
    try {
      if (totalHeightPx <= SAFE_CANVAS_LIMIT_PX) {
        await window.html2pdf().from(pdfTarget).set(opts).save();
      } else {
        await generatePdfInChunks(pdfTarget, headerDiv, opts, SAFE_CANVAS_LIMIT_PX, SCALE);
      }
    } finally {
      pdfTarget.style.display = 'none';
      setIsGeneratingPDF(false);
    }
  };

  const generatePdfInChunks = async (pdfTarget, headerDiv, opts, limitPx, scale) => {
    const cards = Array.from(pdfTarget.querySelectorAll('.trivia_result_summary_question_card'));
    if (cards.length === 0) {
      await window.html2pdf().from(pdfTarget).set(opts).save();
      return;
    }

    // Group question cards into chunks that each stay under the canvas size limit.
    const chunks = [];
    let current = [];
    let currentHeightPx = headerDiv.offsetHeight * scale;
    for (const card of cards) {
      const cardHeightPx = card.offsetHeight * scale;
      if (currentHeightPx + cardHeightPx > limitPx && current.length > 0) {
        chunks.push(current);
        current = [];
        currentHeightPx = 0;
      }
      current.push(card);
      currentHeightPx += cardHeightPx;
    }
    if (current.length > 0) chunks.push(current);

    // Bootstrap a jsPDF document with the correct page format via html2pdf on a
    // 1px placeholder, then delete the empty seed page. We do NOT use html2pdf to
    // render any actual content — all chunks go through html2canvas consistently so
    // text sizes and canvas widths are identical across every page of the PDF.
    // Using html2pdf for chunk 1 and html2canvas for the rest produced different
    // effective source widths (html2pdf clones the element at scrollWidth in an
    // isolated container; html2canvas renders in-situ at the CSS-computed width),
    // causing a visible font-size jump after the first ~9 pages.
    const seedDiv = document.createElement('div');
    seedDiv.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;';
    document.body.appendChild(seedDiv);
    const pdf = await window.html2pdf().from(seedDiv).set(opts).toPdf().get('pdf');
    pdf.deletePage(1);
    document.body.removeChild(seedDiv);

    // Use html2canvas's default rendering width — same options on every chunk
    // is what gives us consistent text size, not an explicit width override.
    // Forcing `width: scrollWidth` made content appear narrow when anything in
    // pdfTarget overflows (wide tables, long URLs, chart containers extend
    // scrollWidth past the visible content). Forcing `windowWidth` also broke
    // responsive letter-spacing on headings.
    const consistentHtml2canvasOpts = { ...opts.html2canvas };

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const [marginTop, marginRight, marginBottom, marginLeft] = opts.margin;
    const contentWidth = pageWidth - marginLeft - marginRight;
    const contentHeight = pageHeight - marginTop - marginBottom;

    // Scan backward from a target cut row to find the nearest mostly-blank row
    // (whitespace between lines/paragraphs). Prevents slicing mid-glyph which
    // produces a strikethrough-like rendering artifact. Search window ≈ 1.5 lines
    // of text at scale 2 (font-size 1.2em × line-height 1.8em × 96dpi × 2 ≈ 110px).
    const CLEAN_ROW_WINDOW_PX = 120;
    const findCleanCutY = (srcCanvas, targetY) => {
      const ctx2 = srcCanvas.getContext('2d');
      let bestY = targetY;
      let minDark = srcCanvas.width + 1;
      const searchLimit = Math.max(0, targetY - CLEAN_ROW_WINDOW_PX);
      for (let y = targetY; y >= searchLimit; y--) {
        const { data } = ctx2.getImageData(0, y, srcCanvas.width, 1);
        let dark = 0;
        for (let p = 0; p < data.length; p += 4) {
          if (data[p] < 240 || data[p + 1] < 240 || data[p + 2] < 240) dark++;
        }
        if (dark < minDark) {
          minDark = dark;
          bestY = y;
          if (dark === 0) break;
        }
      }
      return bestY;
    };

    try {
      for (let i = 0; i < chunks.length; i++) {
        const chunkSet = new Set(chunks[i]);
        cards.forEach((c) => { c.style.display = chunkSet.has(c) ? '' : 'none'; });
        headerDiv.style.display = i === 0 ? '' : 'none';

        await new Promise((resolve) => requestAnimationFrame(resolve));

        const canvas = await html2canvas(pdfTarget, consistentHtml2canvasOpts);
        const pageContentPx = Math.floor((canvas.width * contentHeight) / contentWidth);

        let yPx = 0;
        while (yPx < canvas.height) {
          const rawCutY = yPx + pageContentPx;
          const cutY = rawCutY < canvas.height ? findCleanCutY(canvas, rawCutY) : canvas.height;
          const sliceHeightPx = cutY - yPx;

          const sliceCanvas = document.createElement('canvas');
          sliceCanvas.width = canvas.width;
          sliceCanvas.height = sliceHeightPx;
          const sliceCtx = sliceCanvas.getContext('2d');
          sliceCtx.fillStyle = '#ffffff';
          sliceCtx.fillRect(0, 0, sliceCanvas.width, sliceCanvas.height);
          sliceCtx.drawImage(canvas, 0, yPx, canvas.width, sliceHeightPx, 0, 0, canvas.width, sliceHeightPx);

          const sliceData = sliceCanvas.toDataURL(`image/${opts.image.type}`, opts.image.quality);
          const sliceHeightInches = (sliceHeightPx * contentWidth) / canvas.width;

          pdf.addPage();
          pdf.addImage(sliceData, 'JPEG', marginLeft, marginTop, contentWidth, sliceHeightInches);

          yPx = cutY;
        }
      }

      pdf.save(opts.filename);
    } finally {
      // Restore visibility so the live UI stays intact if the user clicks again.
      cards.forEach((c) => { c.style.display = ''; });
      headerDiv.style.display = '';
    }
  };
  

  const renderPDFContent = () => {
    return (
      <div className="mt-3 trivvy-questions-results-container">
            <div className="mt-3 trivvy-questions-results-container">
            {summaryApiLoading || retakesDataLoading ? (
              <SpinnerLoader />
            ) : summaryData && displayQuestions && displayQuestions.length > 0 ? (
              <div className="mt-2" style={{ width: "100%" }}>
                {displayQuestions.map((question) => {
                  const correct_optionId =
                    question.correct_options[0] &&
                    question.correct_options[0].option_id;
                  let questionResCount = 0;
                  const question_doc =
                    isFiltersApplied && summaryData.question_responses_records
                      ? summaryData.question_responses_records.find(
                        (x) => x._id === question.question_id
                      )
                      : question;
                  if (!question_doc) {
                    questionResCount = 0;
                  } else {
                    questionResCount =
                      question_doc.totalResponses ||
                      question_doc.users_responded;
                  }
                  const odd_or_eve = question.order % 2 == 0 ? "even" : "odd";
                  let isRangeQuestion = false;
                  let rangeAverage = 0;
                  let isCustomTextQuestion = false;
                  let remainingTextQuestions = 0;
                  let maxAvgLimit = 0;
                  let scaleCountObject = {};
                  let totalSumOfNumResponses = 0;
                  let sentimentCountObject = {
                    POSITIVE: 0,
                    NEGATIVE: 0,
                    NEUTRAL: 0,
                  };

                  for (
                    let index = question.linearNumericConfigs.min - 1;
                    index < question.linearNumericConfigs.max;
                    index++
                  ) {
                    scaleCountObject[index + 1] = 0;
                  }

                  console.log({ scaleCountObject });

                  if (question.question_type == "LINEAR_NUMERIC") {
                    maxAvgLimit = question.linearNumericConfigs
                      ? question.linearNumericConfigs.max || 0
                      : 0;
                  }

                  if (question_doc && question_doc.userResponses) {
                    const userResponses = [...question_doc.userResponses];

                    if (
                      userResponses[0] &&
                      userResponses[0].question_type === "TEXT"
                    ) {
                      for (const res of userResponses) {
                        if (
                          res.textSentimentsData &&
                          res.textSentimentsData.sentiment
                        ) {
                          if (
                            res.textSentimentsData &&
                            ["POSITIVE", "NEGATIVE", "NEUTRAL"].includes(
                              res.textSentimentsData.sentiment
                            )
                          ) {
                            sentimentCountObject[
                              res.textSentimentsData.sentiment
                            ] += 1;
                            totalSumOfNumResponses += 1;
                          }
                        }
                      }
                    }

                    if (
                      userResponses[0] &&
                      userResponses[0].question_type == "LINEAR_NUMERIC"
                    ) {
                      isRangeQuestion = true;

                      const selectedAnswersStrings = [];

                      for (const res of userResponses) {
                        if (res.selected_answers && res.selected_answers[0]) {
                          selectedAnswersStrings.push(
                            res.selected_answers[0].text
                          );

                          totalSumOfNumResponses += 1;

                          scaleCountObject[
                            parseInt(res.selected_answers[0].text)
                          ] += 1;
                        }
                      }

                      const selectedAnswersNums = selectedAnswersStrings.map(
                        (x) => {
                          try {
                            return parseInt(x);
                          } catch (error) {
                            return 0;
                          }
                        }
                      );

                      const totalSum = selectedAnswersNums.reduce(
                        (accumulator, currentValue) => {
                          return accumulator + currentValue;
                        },
                        0
                      );

                      rangeAverage = Math.round(
                        totalSum / selectedAnswersNums.length
                      );
                    } else if (
                      userResponses[0] &&
                      userResponses[0].question_type == "TEXT"
                    ) {
                      isCustomTextQuestion = true;
                      remainingTextQuestions =
                        total_people_counts - questionResCount;
                    }
                  } else if (questionResCount > 0) {
                    totalSumOfNumResponses = question.users_responded;
                    if (question.question_type === "LINEAR_NUMERIC") {
                      isRangeQuestion = true;

                      const selectedAnswersStrings =
                        question.linearNumericResponsesCounts &&
                          Object.keys(question.linearNumericResponsesCounts)
                            .length
                          ? Object.values(question.linearNumericResponsesCounts)
                          : [];

                      if (
                        question.linearNumericResponsesCounts &&
                        Object.keys(question.linearNumericResponsesCounts)
                          .length
                      ) {
                        for (
                          let index = question.linearNumericConfigs.min - 1;
                          index < question.linearNumericConfigs.max;
                          index++
                        ) {
                          scaleCountObject[index + 1] =
                            question.linearNumericResponsesCounts[index + 1];
                        }
                      }

                      console.log({ scaleCountObject, selectedAnswersStrings });

                      const selectedAnswersNums = selectedAnswersStrings.map(
                        (x) => {
                          try {
                            return parseInt(x);
                          } catch (error) {
                            return 0;
                          }
                        }
                      );

                      const totalSum = selectedAnswersNums.reduce(
                        (accumulator, currentValue) => {
                          return accumulator + currentValue;
                        },
                        0
                      );

                      rangeAverage = Math.round(
                        totalSum / selectedAnswersNums.length
                      );
                    } else if (question.question_type === "TEXT") {
                      sentimentCountObject = question.sentimentCounts;
                      isCustomTextQuestion = true;
                      remainingTextQuestions =
                        total_people_counts - questionResCount;
                    }
                  }

                  const minScale = question.linearNumericConfigs
                    ? question.linearNumericConfigs.min
                    : 0;
                  const maxScale = question.linearNumericConfigs
                    ? question.linearNumericConfigs.max
                    : 0;

                  const xData = [];
                  const yData = [];

                  const sortedObj = Object.keys(scaleCountObject)
                    .sort((a, b) => a - b) // Sort the keys numerically
                    .reduce((acc, key) => {
                      acc[key] = scaleCountObject[key];
                      return acc;
                    }, {});

                  console.log("itmmmmm", sortedObj);
                  for (const itm in sortedObj) {
                    xData.push(parseInt(itm));
                    yData.push(sortedObj[itm]);
                  }

                  return (
                    <div className="trivia_result_summary_question_card">
                      <div className="trivia_result_summary_question_card_top_questionwrapper">
                        <div
                          className={`TriviaEditViewListUI_leftContainer_singleQuestion_chip_color_${odd_or_eve} mt-2
                        `}
                          style={
                            question.theme_settings
                              ? {
                                backgroundColor:
                                  question.theme_settings.quizBackgroundColor,
                                color: question.theme_settings.quizTextColor,
                              }
                              : {}
                          }
                        >
                          <span>{question.order}</span>
                        </div>
                        <div className="question_text">
                          {parse(question.question_text)}{" "}
                          <small style={{ fontSize: "13px" }}>
                            {" "}
                            {getInputTypeLabel(question.question_type)
                              ? `(${getInputTypeLabel(question.question_type)})`
                              : ""}
                          </small>
                          <div className="mt-2 small_secondary_text">
                          {questionResCount || 0}{" "}  out of  {total_people_counts} {" "}
                            people answered this question
                          </div>
                          <div className="summary_total_avg" >
                            { 
                                currentTrivvy.allowAnonymousResponses && totalSumOfNumResponses  <= 5 && totalSumOfNumResponses  > 0 ? (
                              <div style={{
                                fontSize:'16px',margin:"10px 0px"
                              }}>
                                Too few responses to maintain anonymity
                                </div>) :
                            
                            isRangeQuestion && question.users_responded ? (
                              <span> 
                                <LinearNumericBarGraph
                                  yScales={yData}
                                  xScales={xData}
                                  totalSumOfNumResponses={
                                    totalSumOfNumResponses
                                  }
                                  question={question}
                                />
                              </span>
                            ) : isCustomTextQuestion ? (
                              <div>
                                <span>
                                  Responded :{" "}
                                  {Math.round(
                                    (questionResCount / total_people_counts) *
                                    100
                                  )}
                                  %
                                </span>

                                {currentTrivvy && question.question_type == "TEXT" &&
                                  question.averageSentimentsScore &&
                                  question.averageSentimentsScore.positive >=
                                  0 ? (
                                  <div className="my-2" style={{width:"70%"}}>
                                    
                                    <TextSentimentComponentOverall
                                      questionId={question.question_id}
                                      totalSentimentCounts={
                                        sentimentCountObject
                                      }
                                      data={question.averageSentimentsScore}
                                      totalSumOfNumResponses={
                                        totalSumOfNumResponses
                                      }
                                      user={user}
                                      currentTrivvy={currentTrivvy}
                                    />
                                  </div>
                                ) : (
                                  ""
                                )}
                                <div className="my-2">
                                  {surveyInsights &&
                                    surveyInsights[question.question_id] ? (
                                    <div>
                                       {
                                        insightsLoading ? <Alert className="generate_insights_loading" style={{width:"max-content"}} >
                                          Insights are being generated...
                                        </Alert> :
                                      <Button
                                        outline
                                        onClick={() =>
                                          generateTextQuestionInsights(
                                            question.question_id,
                                            true
                                          )
                                        }
                                        className="generate_insights_btn"
                                        size="sm"
                                      >
                                        Regenerate Insights
                                        {/* for Question
                                  {question.order} */}
                                        <span className="ml-2">
                                          {" "}
                                          <BiRecycle />{" "}
                                        </span>{" "}
                                      </Button>}
                                      <div className="recommendation_textbox">
                                        <h4>
                                         
                                          {/* <BsStars className="mr-2" /> Insights
                                          for Question {question.order} */}
                                        </h4>
                                        {parse(
                                          surveyInsights[question.question_id]
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="placeholder_insights_image_parent" style={{display: "none"}}>
                                      {
                                        insightsLoading ? <Alert className="generate_insights_loading">
                                          Insights are being generated...
                                        </Alert> : <Button
                                          outline
                                          className="generate_insights_btn"
                                          size="sm"
                                          onClick={() =>
                                            generateTextQuestionInsights(
                                              question.question_id,
                                              false
                                            )
                                          }
                                          disabled={!isEndDateBeforeToday}
                                        >
                                          Generate Insights
                                          {/* for Question {question.order} */}
                                          <span className="ml-2">
                                            {" "}
                                            <BiRecycle />{" "}
                                          </span>{" "}
                                        </Button>
                                      }


                                      <div className="mt-2">
                                        <img
                                          src={placeHolderInsights}
                                          className="placeholder_insights_image"
                                        />
                                      </div>
                                      {!isEndDateBeforeToday && (
                                        <div className="mt-2">
                                          * Note: can only be used once Trivvy
                                          has been ended or has passed
                                          its end date
                                        </div>
                                      )}


                                    </div>
                                  )}
                                </div>

                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>

                      {!(currentTrivvy.allowAnonymousResponses &&
                          currentTrivvy.totalSubmissions <= 5 &&
                          currentTrivvy.totalSubmissions > 0) &&  currentTrivvy.isBuiltInWithAiType &&
                        question.question_type == "MCQ" &&
                        question.options &&
                        questionResCount > 0 &&
                        currentTrivvy.totalSubmissions ? (
                        <div className={`trivia_result_summary_question_card_options_wrapper mt-3 ${!isMobile ? "mx-5  px-3" : ""}  `}>
                          {/* Pie chart */} 
                              <OptionsPiechart
                                isFiltersApplied={isFiltersApplied}
                                question={question}
                                option_response_matching_records={
                                  summaryData.option_response_matching_records ||[]
                                }
                              /> 
                        </div>
                      ) : (
                        !(currentTrivvy.allowAnonymousResponses &&
                          currentTrivvy.totalSubmissions <= 5 &&
                          currentTrivvy.totalSubmissions > 0) && 
                        <div className="trivia_result_summary_question_card_options_wrapper mx-5 mt-3 px-3">
                          {question.question_type == "MCQ" &&
                            questionResCount > 0 &&
                            question.options &&
                            question.options.map((option, indx) => {
                              let optionResCount = 0;
                              const option_doc = isFiltersApplied
                                ? summaryData.option_response_matching_records && summaryData.option_response_matching_records.find(
                                  (x) => x._id === option.option_id
                                )
                                : option;

                              if (!option_doc) {
                                optionResCount = 0;
                              } else {
                                optionResCount =
                                  option_doc.totalResponses ||
                                  option_doc.totalResponded;
                              }
                              const progressVal =
                                questionResCount > 0
                                  ? Math.round(
                                    (optionResCount / questionResCount) * 100
                                  )
                                  : 0;
                              return (
                                <div
                                  style={{
                                    marginBottom: "20px",
                                  }}
                                  key={indx}
                                >
                                  <div className={"option_text_result_wrapper"}>
                                    {correct_optionId == option.option_id ? (
                                      <span
                                        style={{
                                          color: "green",
                                          fontWeight: "700",
                                        }}
                                      >
                                        {parse(option.text)} (answer){" "}
                                        <FaThumbsUp size="15" />
                                      </span>
                                    ) : (
                                      <span>{parse(option.text)}</span>
                                    )}

                                    <div>
                                      <span className="small_secondary_text">
                                        {optionResCount} resp.
                                      </span>

                                      <span className="ml-2">
                                        {progressVal}%
                                      </span>
                                    </div>
                                  </div>

                                  <div>
                                    <Progress
                                      className={
                                        progressVal == 100
                                          ? "optionResProgress progressCompleted"
                                          : "optionResProgress"
                                      }
                                      color="primary"
                                      value={progressVal}
                                    ></Progress>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            ) : (
              <EmptyTable
                title={"No data found"}
                subtitle={"No responses have been collected."}
              />
            )}
          </div>
      </div>
    );
  };

  console.log("summaryData", summaryData);
  

  return (
    <div className="res-stats-summary">
      {openDropOffModal && (
        <TrivvyDropoffsModal
          open={openDropOffModal}
          onClose={() => {
            setOpenDropOffModal(false);
          }}
          triviaId={currentTrivvy && currentTrivvy._id}
        />
      )}

      {openSubmissionModal && currentTrivvy && (
        <Modal isOpen={true}>
          <ModalHeader
            className="trivia_modal_header_bg"
            toggle={() => setOpenSubmissionsModal(false)}
          >
            Submissions
          </ModalHeader>
          <ModalBody>
            <TriviaResultsResponses
              questions={currentTrivvy.questions}
              surveyData={currentTrivvy}
              allowAttempts={currentTrivvy.allowAttempts}
              numberOfAttempts={currentTrivvy.numberOfAttempts}
              hideActions
              showTableForSummaryResponses
            />
          </ModalBody>
        </Modal>
      )}




      <div className="d-flex justify-content-center mt-3">
        <MultirangeDatePickerDesigned
          dateRange={dateRange}
          handleDateChange={handleDateChange}
          headingText={"Responses"}
          user={user}
        />


        <Button color="info" 
        className="trivvy-download-btn-question-res"
        onClick={() => generatePDF()}
        disabled={isGeneratingPDF}
        style={{
          opacity: isGeneratingPDF ? 0.6 : 1,
          pointerEvents: isGeneratingPDF ? 'none' : 'auto',
          transition: 'opacity 0.3s ease',
        }}
      >
        {isGeneratingPDF ? 'Generating PDF...' : 'Download Results'}
        </Button>

      </div>



      <div className="d-flex">
        {/* <div className="ml-3">
          {summaryData &&
          summaryData.question_responses_records &&
          summaryData.question_responses_records.length &&
          questions ? (
            <CSVLink
              data={getDataForSummary()}
              headers={summaryHeaders}
              filename={`Trivvy Summary-${moment().format("MM/DD/YYYY")}.csv`}
              separator={","}
              target="_blank"
              className="ml-2 btn trivia-action-button-main h-fitcontent trivvy-export-table-btn"
            >
              Export to CSV <BsDownload size={13} />
            </CSVLink>
          ) : (
            ""
          )}
        </div> */}

        {allowAttempts > 0 && currentTrivvy ? (
          <Select
            options={getAttemptNumberFilterOptions(
              currentTrivvy.numberOfAttempts
            )}
            className="ml-4 select-trivvy-attempt-filter"
            placeholder={"Select attempt number"}
            value={attemptNumber}
            onChange={(e) => {
              setAttemptNumber(e.value);
              getSummaryData({
                dates: dateRange,
                attempts: e.value,
              });
            }}
          />
        ) : (
          ""
        )}
      </div>

      <div>
        <div className="pt-3 pb-2">
          <div>
            {/* <h2
                style={{
                  fontWeight: 300,
                }}
              >
                Big Picture
              </h2> */}
          </div>

          <div id="pdf_content_container" style={{ display: 'none' }}>
            {renderPDFContent()} {/* Render your questions block here */}
          </div>

          <div className="mt-3 trivvy-questions-results-container">
            {summaryApiLoading || retakesDataLoading ? (
              <SpinnerLoader />
            ) : summaryData && displayQuestions && displayQuestions.length > 0 ? (
              <div className="mt-2" style={{ width: "100%" }}>
                {displayQuestions.map((question) => {
                   
                  const correct_optionId =
                    question.correct_options[0] &&
                    question.correct_options[0].option_id;
                  let questionResCount = 0;
                  const question_doc =
                    isFiltersApplied && summaryData.question_responses_records
                      ? summaryData.question_responses_records.find(
                        (x) => x._id === question.question_id
                      )
                      : question;
                  if (!question_doc) {
                    questionResCount = 0;
                  } else {
                    questionResCount =
                      question_doc.totalResponses ||
                      question_doc.users_responded;
                  }
                  const odd_or_eve = question.order % 2 == 0 ? "even" : "odd";
                  let isRangeQuestion = false;
                  let rangeAverage = 0;
                  let isCustomTextQuestion = false;
                  let remainingTextQuestions = 0;
                  let maxAvgLimit = 0;
                  let scaleCountObject = {};
                  let totalSumOfNumResponses = 0;
                  let sentimentCountObject = {
                    POSITIVE: 0,
                    NEGATIVE: 0,
                    NEUTRAL: 0,
                  };

                  for (
                    let index = question.linearNumericConfigs.min - 1;
                    index < question.linearNumericConfigs.max;
                    index++
                  ) {
                    scaleCountObject[index + 1] = 0;
                  }

                  console.log({ scaleCountObject });

                  if (question.question_type == "LINEAR_NUMERIC") {
                    maxAvgLimit = question.linearNumericConfigs
                      ? question.linearNumericConfigs.max || 0
                      : 0;
                  }

                  if (question_doc && question_doc.userResponses) {
                    const userResponses = [...question_doc.userResponses];

                    if (
                      userResponses[0] &&
                      userResponses[0].question_type === "TEXT"
                    ) {
                      for (const res of userResponses) {
                        if (
                          res.textSentimentsData &&
                          res.textSentimentsData.sentiment
                        ) {
                          if (
                            res.textSentimentsData &&
                            ["POSITIVE", "NEGATIVE", "NEUTRAL"].includes(
                              res.textSentimentsData.sentiment
                            )
                          ) {
                            sentimentCountObject[
                              res.textSentimentsData.sentiment
                            ] += 1;
                            totalSumOfNumResponses += 1;
                          }
                        }
                      }
                    }

                    if (
                      userResponses[0] &&
                      userResponses[0].question_type == "LINEAR_NUMERIC"
                    ) {
                      isRangeQuestion = true;

                      const selectedAnswersStrings = [];

                      for (const res of userResponses) {
                        if (res.selected_answers && res.selected_answers[0]) {
                          selectedAnswersStrings.push(
                            res.selected_answers[0].text
                          );

                          totalSumOfNumResponses += 1;

                          scaleCountObject[
                            parseInt(res.selected_answers[0].text)
                          ] += 1;
                        }
                      }

                      const selectedAnswersNums = selectedAnswersStrings.map(
                        (x) => {
                          try {
                            return parseInt(x);
                          } catch (error) {
                            return 0;
                          }
                        }
                      );

                      const totalSum = selectedAnswersNums.reduce(
                        (accumulator, currentValue) => {
                          return accumulator + currentValue;
                        },
                        0
                      );

                      rangeAverage = Math.round(
                        totalSum / selectedAnswersNums.length
                      );
                    } else if (
                      userResponses[0] &&
                      userResponses[0].question_type == "TEXT"
                    ) {
                      isCustomTextQuestion = true;
                      remainingTextQuestions =
                        total_people_counts - questionResCount;
                    }
                  } else if (questionResCount > 0) {
                    totalSumOfNumResponses = question.users_responded;
                    if (question.question_type === "LINEAR_NUMERIC") {
                      isRangeQuestion = true;

                      const selectedAnswersStrings =
                        question.linearNumericResponsesCounts &&
                          Object.keys(question.linearNumericResponsesCounts)
                            .length
                          ? Object.values(question.linearNumericResponsesCounts)
                          : [];

                      if (
                        question.linearNumericResponsesCounts &&
                        Object.keys(question.linearNumericResponsesCounts)
                          .length
                      ) {
                        for (
                          let index = question.linearNumericConfigs.min - 1;
                          index < question.linearNumericConfigs.max;
                          index++
                        ) {
                          scaleCountObject[index + 1] =
                            question.linearNumericResponsesCounts[index + 1];
                        }
                      }

                      console.log({ scaleCountObject, selectedAnswersStrings });

                      const selectedAnswersNums = selectedAnswersStrings.map(
                        (x) => {
                          try {
                            return parseInt(x);
                          } catch (error) {
                            return 0;
                          }
                        }
                      );

                      const totalSum = selectedAnswersNums.reduce(
                        (accumulator, currentValue) => {
                          return accumulator + currentValue;
                        },
                        0
                      );

                      rangeAverage = Math.round(
                        totalSum / selectedAnswersNums.length
                      );
                    } else if (question.question_type === "TEXT") {
                      sentimentCountObject = question.sentimentCounts;
                      isCustomTextQuestion = true;
                      remainingTextQuestions =
                        total_people_counts - questionResCount;
                    }
                  }

                  const minScale = question.linearNumericConfigs
                    ? question.linearNumericConfigs.min
                    : 0;
                  const maxScale = question.linearNumericConfigs
                    ? question.linearNumericConfigs.max
                    : 0;

                  const xData = [];
                  const yData = [];

                  const sortedObj = Object.keys(scaleCountObject)
                    .sort((a, b) => a - b) // Sort the keys numerically
                    .reduce((acc, key) => {
                      acc[key] = scaleCountObject[key];
                      return acc;
                    }, {});

                  console.log("itmmmmm", sortedObj);
                  for (const itm in sortedObj) {
                    xData.push(parseInt(itm));
                    yData.push(sortedObj[itm]);
                  }

                  return (
                    <div className="trivia_result_summary_question_card">
                      <div className="trivia_result_summary_question_card_top_questionwrapper">
                        <div
                          className={`TriviaEditViewListUI_leftContainer_singleQuestion_chip_color_${odd_or_eve} mt-2
                        `}
                          style={
                            question.theme_settings
                              ? {
                                backgroundColor:
                                  question.theme_settings.quizBackgroundColor,
                                color: question.theme_settings.quizTextColor,
                              }
                              : {}
                          }
                        >
                          <span>{question.order}</span>
                        </div>
                        <div className="question_text">
                          {parse(question.question_text)}{" "}
                          <small style={{ fontSize: "13px" }}>
                            {" "}
                            {getInputTypeLabel(question.question_type)
                              ? `(${getInputTypeLabel(question.question_type)})`
                              : ""}
                          </small>
                          <div className="mt-2 small_secondary_text">
                          {questionResCount || 0}{" "}  out of  {total_people_counts} {" "}
                            people answered this question
                          </div>

                          {  currentTrivvy.allowAnonymousResponses && totalSumOfNumResponses <= 5 && totalSumOfNumResponses > 0 ? (
                              <div style={{
                                fontSize:'16px',margin:"10px 0px"
                              }}>
                                Too few responses to maintain anonymity
                                </div>
                              ) : (
                              <div className="summary_total_avg">
                            {isRangeQuestion && question.users_responded ? (
                              <span>
                                <LinearNumericBarGraph
                                  yScales={yData}
                                  xScales={xData}
                                  totalSumOfNumResponses={
                                    totalSumOfNumResponses
                                  }
                                  question={question}
                                />
                              </span>
                            ) : isCustomTextQuestion ? (
                              <div>
                                <span>
                                  Responded :{" "}
                                  {Math.round(
                                    (questionResCount / total_people_counts) *
                                    100
                                  )}
                                  %
                                </span>

                                {currentTrivvy && question.question_type == "TEXT" &&
                                  question.averageSentimentsScore &&
                                  question.averageSentimentsScore.positive >=
                                  0 ? (
                                  <div className="my-2" style={{width:"70%"}}>
                                    
                                    <TextSentimentComponentOverall
                                      questionId={question.question_id}
                                      totalSentimentCounts={
                                        sentimentCountObject
                                      }
                                      data={question.averageSentimentsScore}
                                      totalSumOfNumResponses={
                                        totalSumOfNumResponses
                                      }
                                      user={user}
                                      currentTrivvy={currentTrivvy}
                                    />
                                  </div>
                                ) : (
                                  ""
                                )}
                                <div className="my-2">
                                  {surveyInsights &&
                                    surveyInsights[question.question_id] ? (
                                    <div>
                                       {
                                        insightsLoading ? <Alert className="generate_insights_loading" style={{width:"max-content"}} >
                                          Insights are being generated...
                                        </Alert> :
                                      <Button
                                        outline
                                        onClick={() =>
                                          generateTextQuestionInsights(
                                            question.question_id,
                                            true
                                          )
                                        }
                                        className="generate_insights_btn"
                                        size="sm"
                                      >
                                        Regenerate Insights
                                        {/* for Question
                                  {question.order} */}
                                        <span className="ml-2">
                                          {" "}
                                          <BiRecycle />{" "}
                                        </span>{" "}
                                      </Button>}
                                      <div className="recommendation_textbox">
                                        <h4>
                                         
                                          {/* <BsStars className="mr-2" /> Insights
                                          for Question {question.order} */}
                                        </h4>
                                        {parse(
                                          surveyInsights[question.question_id]
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="placeholder_insights_image_parent">
                                      {
                                        insightsLoading ? <Alert className="generate_insights_loading">
                                          Insights are being generated...
                                        </Alert> : <Button
                                          outline
                                          className="generate_insights_btn"
                                          size="sm"
                                          onClick={() =>
                                            generateTextQuestionInsights(
                                              question.question_id,
                                              false
                                            )
                                          }
                                          disabled={!isEndDateBeforeToday}
                                        >
                                          Generate Insights
                                          {/* for Question {question.order} */}
                                          <span className="ml-2">
                                            {" "}
                                            <BiRecycle />{" "}
                                          </span>{" "}
                                        </Button>
                                      }


                                      <div className="mt-2">
                                        <img
                                          src={placeHolderInsights}
                                          className="placeholder_insights_image"
                                        />
                                      </div>
                                      {!isEndDateBeforeToday && (
                                        <div className="mt-2">
                                          * Note: can only be used once Trivvy
                                          has been ended or has passed
                                          its end date
                                        </div>
                                      )}


                                    </div>
                                  )}
                                </div>

                              </div>
                            ) : (
                              ""
                            )}
                          </div>) }

                          
                          
                        </div>
                      </div>

                      {!(currentTrivvy.allowAnonymousResponses &&
                          currentTrivvy.totalSubmissions <= 5 &&
                          currentTrivvy.totalSubmissions > 0) &&  currentTrivvy.isBuiltInWithAiType &&
                        question.question_type == "MCQ" &&
                        question.options &&
                        questionResCount > 0 &&
                        currentTrivvy.totalSubmissions ? (
                        <div className={`trivia_result_summary_question_card_options_wrapper mt-3 ${!isMobile ? "mx-5  px-3" : ""}  `}>
                          {/* Pie chart */} 
                              <OptionsPiechart
                                isFiltersApplied={isFiltersApplied}
                                question={question}
                                option_response_matching_records={
                                  summaryData.option_response_matching_records ||[]
                                }
                              /> 
                        </div>
                      ) : ( !(currentTrivvy.allowAnonymousResponses &&
                          currentTrivvy.totalSubmissions <= 5 &&
                          currentTrivvy.totalSubmissions > 0) && 
                        <div className="trivia_result_summary_question_card_options_wrapper mx-5 mt-3 px-3">
                          {question.question_type == "MCQ" &&
                            questionResCount > 0 &&
                            question.options &&
                            question.options.map((option, indx) => {
                              let optionResCount = 0;
                              const option_doc = isFiltersApplied
                                ? summaryData.option_response_matching_records && summaryData.option_response_matching_records.find(
                                  (x) => x._id === option.option_id
                                )
                                : option;

                              if (!option_doc) {
                                optionResCount = 0;
                              } else {
                                optionResCount =
                                  option_doc.totalResponses ||
                                  option_doc.totalResponded;
                              }
                              const progressVal =
                                questionResCount > 0
                                  ? Math.round(
                                    (optionResCount / questionResCount) * 100
                                  )
                                  : 0;
                              return (
                                <div
                                  style={{
                                    marginBottom: "20px",
                                  }}
                                  key={indx}
                                >
                                  <div className={"option_text_result_wrapper"}>
                                    {correct_optionId == option.option_id ? (
                                      <span
                                        style={{
                                          color: "green",
                                          fontWeight: "700",
                                        }}
                                      >
                                        {parse(option.text)} (answer){" "}
                                        <FaThumbsUp size="15" />
                                      </span>
                                    ) : (
                                      <span>{parse(option.text)}</span>
                                    )}

                                    <div>
                                      <span className="small_secondary_text">
                                        {optionResCount} resp.
                                      </span>

                                      <span className="ml-2">
                                        {progressVal}%
                                      </span>
                                    </div>
                                  </div>

                                  <div>
                                    <Progress
                                      className={
                                        progressVal == 100
                                          ? "optionResProgress progressCompleted"
                                          : "optionResProgress"
                                      }
                                      color="primary"
                                      value={progressVal}
                                    ></Progress>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            ) : (
              <EmptyTable
                title={"No data found"}
                subtitle={"No responses have been collected."}
              />
            )}
          </div>
        
        
        </div>
      </div>
    </div>
  );
}

export default withLoading(TriviaResultsSummary, axios);
